/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Billing_Cancel_TitleInputs */

const en_settings_billing_cancel_title = /** @type {(inputs: Settings_Billing_Cancel_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel subscription`)
};

/**
* | output |
* | --- |
* | "Cancel subscription" |
*
* @param {Settings_Billing_Cancel_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_billing_cancel_title = /** @type {((inputs?: Settings_Billing_Cancel_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Billing_Cancel_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_billing_cancel_title(inputs)
});
export { settings_billing_cancel_title as "settings.billing.cancel_title" }